import { AxiosRequestConfig, AxiosResponse } from 'axios';
import {
	ClaimCreateRequest,
	ClaimResponse,
	ClaimUpdateRequest,
	ReserveHistoryResponse,
	SubClaimPayableCreateRequest,
	SubClaimPayableListsResponse,
	SubClaimPayableResponse,
	SubClaimPayableReverseRequest,
	SubClaimSummary,
} from '../types/claim';
import { getApiUrl } from '../util/util';
import { get, post } from './http';

interface ClaimsApi {
	getClaimsForPolicy(
		authorizationToken: string,
		policyLocator: string,
		config?: AxiosRequestConfig<any>,
	): Promise<AxiosResponse<ClaimResponse[]>>;
	getClaim(
		authorizationToken: string,
		claimLocator: string,
	): Promise<AxiosResponse<ClaimResponse>>;
	createClaim(
		authorizationToken: string,
		createReq: ClaimCreateRequest,
	): Promise<AxiosResponse<ClaimResponse>>;
	updateClaim(
		authorizationToken: string,
		claimLocator: string,
		updateReq: ClaimUpdateRequest,
	): Promise<AxiosResponse<ClaimResponse>>;
	discardClaim(
		authorizationToken: string,
		claimLocator: string,
	): Promise<AxiosResponse<{}>>;
	createSubclaimPayable(
		authorizationToken: string,
		sublcaimPayable: SubClaimPayableCreateRequest,
	): Promise<AxiosResponse<SubClaimPayableResponse>>;
	getPayable(
		authorizationToken: string,
		payableLocator: string,
	): Promise<AxiosResponse<SubClaimPayableResponse>>;
	reversePayable(
		authorizationToken: string,
		reversalRequest: SubClaimPayableReverseRequest,
	): Promise<AxiosResponse<SubClaimPayableResponse>>;
	fetchSubclaimSummary(
		authorizationToken: string,
		subclaimLocator: string,
	): Promise<AxiosResponse<SubClaimSummary>>;
	fetchSubclaimPayables(
		authorizationToken: string,
		subclaimLocator: string,
	): Promise<AxiosResponse<SubClaimPayableListsResponse>>;
	fetchSubclaimReserves(
		authorizationToken: string,
		subclaimLocator: string,
	): Promise<AxiosResponse<ReserveHistoryResponse>>;
}

export default {
	async getClaimsForPolicy(
		authorizationToken: string,
		policyLocator: string,
		config?: AxiosRequestConfig<any>,
	) {
		return get(
			`${getApiUrl()}/policy/${policyLocator}/claims`,
			authorizationToken,
			config,
		);
	},
	async getClaim(authorizationToken: string, claimLocator: string) {
		return get(`${getApiUrl()}/claim/${claimLocator}`, authorizationToken);
	},
	async createClaim(authorizationToken: string, createReq: ClaimCreateRequest) {
		return post(`${getApiUrl()}/claim`, authorizationToken, createReq);
	},
	async updateClaim(
		authorizationToken: string,
		claimLocator: string,
		updateReq: ClaimUpdateRequest,
	) {
		return post(
			`${getApiUrl()}/claim/${claimLocator}/update`,
			authorizationToken,
			updateReq,
		);
	},
	async discardClaim(authorizationToken: string, claimLocator: string) {
		return post(
			`${getApiUrl()}/claim/${claimLocator}/discard`,
			authorizationToken,
		);
	},
	async createSubclaimPayable(
		authorizationToken: string,
		sublcaimPayable: SubClaimPayableCreateRequest,
	) {
		return post(
			`${getApiUrl()}/claims/payables`,
			authorizationToken,
			sublcaimPayable,
		);
	},
	async getPayable(authorizationToken: string, payableLocator: string) {
		return get(
			`${getApiUrl()}/claims/payables/${payableLocator}`,
			authorizationToken,
		);
	},
	async reversePayable(
		authorizationToken: string,
		reversalRequest: SubClaimPayableReverseRequest,
	) {
		return post(
			`${getApiUrl()}/claims/payables/reversals`,
			authorizationToken,
			reversalRequest,
		);
	},
	async fetchSubclaimSummary(
		authorizationToken: string,
		subclaimLocator: string,
	) {
		return get(
			`${getApiUrl()}/subClaim/${subclaimLocator}/summary`,
			authorizationToken,
		);
	},
	async fetchSubclaimPayables(
		authorizationToken: string,
		subclaimLocator: string,
	) {
		return get(
			`${getApiUrl()}/subClaim/${subclaimLocator}/payables`,
			authorizationToken,
		);
	},
	async fetchSubclaimReserves(
		authorizationToken: string,
		subclaimLocator: string,
	) {
		return get(
			`${getApiUrl()}/subClaim/${subclaimLocator}/reserves`,
			authorizationToken,
		);
	},
} as ClaimsApi;
